<template>
    <div :class="'dashboard-items-box' + (open ? ' opened-dropdown' : '')" v-if="!$_.isEmpty(list)">
        <p class="box-title js-toggle-dashboard-items" @click="openClick">
            <span>{{title}}</span>
        </p>
        <dropdown-item-component :visible="open">
            <div class="dashboard-items-dropdown">
                <component :is="draggable ? 'draggable' : 'div'" tag="div" v-model="list" class="dragArea" v-bind="getOptions" handle=".handle">
                    <dashbord-dropdown-item v-for="(item,index) in list" :key="index" :item="item" :draggable="draggable" :actions="getActions(item.type)"></dashbord-dropdown-item>
                </component>
                <span v-if="showMoreLink" :class="'js-show-more-dashboard-items' + (!showMore ? ' active' : '')" @click="showMore=!showMore">
                                        <span>{{showMore ? 'Показать ещё' : 'Скрыть'}}</span>
                                        <icon-base width="8" height="6" viewBox="0 0 8 6"><icon-arrow/></icon-base>
                                    </span>
            </div>
        </dropdown-item-component>
    </div>
</template>

<script>
    import {mapState} from 'vuex'
    import draggable from 'vuedraggable'
    import DropdownItemComponent from "../common/Dropdown";
    import ControlsDropdown from "./ControlsDropdown";
    import DashbordDropdownItem from "./DashbordDropdownItem";
    import IconBase from "../common/IconBase";
    import IconArrow from "../common/icons/IconArrow";

    export default {
        name: 'dashbord-dropdown',
        components: {
            IconBase,
            IconArrow,
            DashbordDropdownItem,
            ControlsDropdown,
            DropdownItemComponent,
            draggable
        },
        props: {
            title: String,
            listType: {
                type: String,
                default: 'favorite'
            },
            listMutation : {
                type: String,
                default: 'setFavorite'
            },
            opened : {
                type: Boolean,
                defalt: false
            },
            isMobile: {
                type: Boolean,
                defalt: false
            },
            draggable: {
                type: Boolean,
                defalt: false
            }
        },
        data (){
           return {
               showMore: true,
               open: false,
           }
        },
        computed: {
            ...mapState({
                types: state => state.main.types,
            }),
            list: {
                get() {
                    let list = this.$store.state.main[this.listType];
                    if (this.showMore) {
                        list = list.slice(0, this.isMobile ? 4 : 5);
                    }
                    return list;
                },
                set(value) {
                    this.$store.dispatch('main/'+ this.listMutation, value);
                    this.$store.commit('main/'+ this.listMutation, value)
                }
            },
            listCount() {
                return  this.$store.state.main[this.listType].length
            },
            getOptions() {
                return {
                    animation: 200,
                    group: "description",
                    disabled: false,
                    ghostClass: "ghost",
                    forceFallback: true
                }
            },
            showMoreLink() {
                if (this.isMobile) {
                    return this.listCount > 4
                } else {
                    return this.listCount > 5
                }
            }
        },
        created() {
            this.open = this.opened
        },
        methods: {
            getTypeTitle(type) {
                return this.types.find(x => (type === x.type)).name
            },
            itemClick() {
                this.$router.push('/knowledge-base')
            },
            openClick() {
                this.open=!this.open;
            },
            getActions(type) {
                if (!(this.listType === 'favorite')) return [];
                switch (type) {
                    case 'knowledge-base':
                        return [
                            {
                                title: 'Удалить из избранного',
                                action: 'main/removeFavorite'
                            },
                        ];
                    default : return []
                }
            }
        },
    }
</script>


<style scoped>
    .dashboard-items-dropdown {
        display: block;
    }

</style>
